<button
    name="displayPreferences"
    type="button"
    id="displayPreferencesToolBtn"
    class="btn btn-default nlr-icon-btn"
    right-click="displayPreferences"
    [title]="getTooltip()"
    (click)="toggleWidgetVisibility()"
    [ngClass]="{active : isWidgetActive()}">
    <i class="nlrp-icon nlrp-icon-manage-feature-display-preferences"></i>
</button>

@if (isWidgetActive()) {
    <div
        id="displayPreferences"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        style="visibility: hidden"
        #widget>
        <form
            id="displayPreferencesForm"
            name="displayPreferencesForm"
            novalidate
            autocomplete="off"
            #displayPreferencesForm="ngForm">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <nlrp-help-link
                    [url]="helpLinkUrl"
                    [pageTitle]="helpPageTitle"></nlrp-help-link>
                <div class="pull-right btn-group btn-group-xs">
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        [title]="widgetConfig.closeTooltip"
                        (click)="toggleWidgetVisibility()"></i>
                </div>
            </div>
            <div class="widget-content">
                <div class="col-xs-12">
                    <div
                        class="checkbox"
                        title="Show hidden annotations">
                        <div
                            class="checkbox-inline"
                            id="showHiddenAnnotations">
                            <i
                                class="nlrp-icon"
                                [ngClass]="{'active': this.showHiddenAnnotations,
                            'nlrp-icon-check-box-selected' : this.showHiddenAnnotations,
                            'nlrp-icon-check-box-unselected': !this.showHiddenAnnotations}"
                                (click)="toggleShowHiddenAnnotations()"></i>
                            <span (click)="toggleShowHiddenAnnotations()">Show hidden annotations</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div
                        class="checkbox"
                        title="Show hidden geometry features">
                        <div class="checkbox-inline">
                            <i
                                class="nlrp-icon"
                                id="showHiddenGeometryFeatures"
                                [ngClass]="{'active': showHiddenGeometryFeatures,
                           'nlrp-icon-check-box-selected' : showHiddenGeometryFeatures,
                           'nlrp-icon-check-box-unselected': !showHiddenGeometryFeatures}"
                                (click)="toggleShowHiddenGeometryFeatures()"></i>
                            <span (click)="toggleShowHiddenGeometryFeatures()">Show hidden geometry features</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div
                        class="checkbox"
                        title="Show main plan print area">
                        <div class="checkbox-inline">
                            <i
                                class="nlrp-icon"
                                id="showMainPlanPrintArea"
                                [ngClass]="{'active': showPrintArea && !showPrintAreaIsDisabled(),
                           'nlrp-icon-check-box-selected' : showPrintArea && !showPrintAreaIsDisabled(),
                           'nlrp-icon-check-box-unselected': !showPrintArea && !showPrintAreaIsDisabled(),
                           'nlrp-icon-check-box-indeterminate' : showPrintAreaIsDisabled()}"
                                (click)="toggleShowPrintArea()"></i>
                            <span (click)="toggleShowPrintArea()">Show main plan print area</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div
                        class="checkbox"
                        title="Show enlargement polygon(s)">
                        <div class="checkbox-inline">
                            <i
                                class="nlrp-icon"
                                id="showEnlargementPolygons"
                                [ngClass]="{'active': showEnlargementPolygons && !showEnlargementPolygonsIsDisabled(),
                           'nlrp-icon-check-box-selected' : showEnlargementPolygons && !showEnlargementPolygonsIsDisabled(),
                           'nlrp-icon-check-box-unselected': !showEnlargementPolygons && !showEnlargementPolygonsIsDisabled(),
                           'nlrp-icon-check-box-indeterminate' : showEnlargementPolygonsIsDisabled()}"
                                (click)="toggleShowEnlargementFeatures()"></i>
                            <span (click)="toggleShowEnlargementFeatures()">Show enlargement polygon(s)</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div
                        class="checkbox"
                        title="Show clipping polygon(s)">
                        <div class="checkbox-inline">
                            <i
                                class="nlrp-icon"
                                id="{{mainPlan ? 'showClippingPolygons' : 'hideFeaturesOutsideClippingPolygon'}}"
                                [ngClass]="{'active': showClippingPolygons && !showClippingPolygonsIsDisabled(),
                           'nlrp-icon-check-box-selected' : showClippingPolygons && !showClippingPolygonsIsDisabled(),
                           'nlrp-icon-check-box-unselected': !showClippingPolygons && !showClippingPolygonsIsDisabled(),
                           'nlrp-icon-check-box-indeterminate' : showClippingPolygonsIsDisabled()}"
                                (click)="toggleShowClippingPolygons()"></i>
                            <span (click)="toggleShowClippingPolygons()">
                                {{mainPlan ? 'Show clipping polygon(s)' : 'Hide features outside clipping polygon' }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 inline-bottom-buttons">
                    <button
                        class="btn btn-default nlr-btn-sm"
                        id="applyBtn"
                        title="Apply"
                        [disabled]="applyDisabled"
                        (click)="displayPreferencesChanged()">
                        Apply
                    </button>
                    <button
                        class="btn btn-warning nlr-btn-sm"
                        id="closeBtn"
                        title="Close"
                        (click)="toggleWidgetVisibility()">
                        Close
                    </button>
                </div>
            </div>
        </form>
    </div>
}
